import { render, staticRenderFns } from "./DirectMessageList.vue?vue&type=template&id=3942214f&scoped=true&"
import script from "./DirectMessageList.vue?vue&type=script&lang=js&"
export * from "./DirectMessageList.vue?vue&type=script&lang=js&"
import style0 from "./DirectMessageList.vue?vue&type=style&index=0&id=3942214f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942214f",
  null
  
)

export default component.exports